import React from 'react';

// Focuz brand mark — an indigo tile with a white "focus ring" + center dot.
// Inline SVG so it stays crisp at any size and needs no raster asset.
let _uid = 0;
export const LogoMark = ({ size = 32, className, title }) => {
    const gid = `focuz-grad-${++_uid}`;
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            focusable="false"
        >
            {title && <title>{title}</title>}
            <defs>
                <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#5a5af2" />
                    <stop offset="1" stopColor="#2a28c4" />
                </linearGradient>
            </defs>
            <rect x="0" y="0" width="40" height="40" rx="10" fill={`url(#${gid})`} />
            <circle cx="20" cy="20" r="11" fill="none" stroke="#fff" strokeWidth="3.2" strokeOpacity="0.95" />
            <circle cx="20" cy="20" r="4.4" fill="#fff" />
        </svg>
    );
};

export default LogoMark;
